'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAddLocation = function MdAddLocation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 16.6v-3.2h-5v-5h-3.2v5h-5v3.2h5v5h3.2v-5h5z m-6.6-13.2c6.4 0 11.6 5.2 11.6 11.6 0 8.8-11.6 21.6-11.6 21.6s-11.6-12.8-11.6-21.6c0-6.4 5.2-11.6 11.6-11.6z' })
        )
    );
};

exports.default = MdAddLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/add-location.js
// module id = 2551
// module chunks = 0